<template>
  <div>
    <v-row class="pb-3">
      <v-col cols="12">
        <span class="pl-3 body-1">Produtos selecionados </span>
        <span class="body-1"> ({{ campaign.offer_sales.length }})</span>
      </v-col>
    </v-row>
    <v-row class="mt-n8">
      <v-col cols="12">
        <div v-if="campaign.offer_sales.length" class="modal-div">
          <span v-if="!disabled" class="px-3 label-remove-all" @click="clearAll">Remover todos</span>
          <div v-for="(item, chosenIndex) in formattedChosenItems.slice().reverse()" :key="chosenIndex" class="px-3 mt-3">
            <v-chip
              v-if="!item.isGroup"
              class="body-2"
              close-icon="close"
              close
              :disabled="item.disabled || disabled"
              @click:close="$emit('set-item', item, campaign.offer_sales, searchedItems)"
            >
              <v-tooltip right>
                <template #activator="{ on }">
                  <span v-on="on">
                    {{ item.sku }} -
                    {{ putEllipsis(item.name, 20) }}
                  </span>
                </template>
                <span>{{ item.name }}</span>
              </v-tooltip>
            </v-chip>
            <v-card v-else class="my-2 elevation-0" color="cinza-l80">
              <v-toolbar height="30" color="cinza-l80" flat>
                <v-tooltip right>
                  <template #activator="{ on }">
                    <span class="texto-corrido" v-on="on">
                      {{ putEllipsis(item.name, 30) }}
                    </span>
                  </template>
                  <span>{{ item.name }}</span>
                </v-tooltip>
                <v-spacer />
                <mf-button
                  color="cinza-0"
                  type="icon"
                  icon="close"
                  size="sm"
                  :disabled="item.disabled || disabled"
                  @click="$emit('remove-group', item, campaign.offer_sales, searchedItems)"
                />
              </v-toolbar>
              <v-card-text>
                <v-chip
                  v-for="(product, chosenProductIndex) in item.products"
                  :key="chosenProductIndex"
                  class="mb-2"
                  close
                  close-icon="close"
                  :disabled="item.disabled || disabled"
                  @click:close="$emit('set-item', product, campaign.offer_sales, searchedItems)"
                >
                  <v-tooltip right>
                    <template #activator="{ on }">
                      <span v-on="on">
                        {{ product.sku }} -
                        {{ putEllipsis(product.name, 18) }}
                      </span>
                    </template>
                    <span>{{ product.name }}</span>
                  </v-tooltip>
                </v-chip>
              </v-card-text>
            </v-card>
          </div>
        </div>
        <div v-else>
          <v-alert class="ma-3" type="info" outlined> Selecione um produto </v-alert>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { putEllipsis } from '@/config/helpers.js'

export default {
  name: 'SelectedCampaignItems',

  props: {
    campaign: {
      type: Object,
      required: true,
    },
    searchedItems: {
      type: Array,
      default: () => [],
    },
    searchValue: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    formattedChosenItems() {
      return this.campaign.offer_sales.reduce((accumulator, current) => {
        if (current.isGroup) {
          const productIndex = accumulator.findIndex((item) => item._id && item._id === current.groupInfo._id)
          if (productIndex >= 0) {
            accumulator[productIndex].products.push(current)
          } else {
            const {
              nameGroup,
              isGroup,
              disabled,
              groupInfo: { _id, __typename },
              ...product
            } = current
            const group = {
              name: nameGroup,
              disabled: disabled || false,
              isGroup,
              _id,
              __typename,
              products: [product],
            }
            accumulator.push(group)
          }
        } else {
          accumulator.push(current)
        }
        return accumulator
      }, [])
    },
  },

  methods: {
    putEllipsis,

    clearAll() {
      this.loading = true
      this.campaign.offer_sales = this.campaign.offer_sales.filter((group) => group.disabled)

      if (this.searchValue) this.$emit('search-item', this.searchValue)
      else this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-div {
  .label-remove-all {
    font-size: 16px !important;
    color: $marca-0-l40;
    text-decoration: underline;
    cursor: pointer;
  }
}

::v-deep .v-chip {
  width: 100%;
  margin: auto;
  justify-content: center;
  border-radius: 5px;
  height: 48px;
  background-color: #f3f3f3 !important;

  .v-chip__content {
    width: 100%;
    justify-content: space-between;
  }
}
</style>
